import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const startPickRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/picks/:id/start',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/picks/:id/start' \\
--header 'Authorization: Bearer <TOKEN>' \\
--header 'Content-Type: application/json'
`,
};

const startPickResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 129,
        'number': 'S10074',
        'status': 'Started',
        'type': 'Pick',
        'priority': '3-Normal',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'username': 'admin',
        'dateCreated': '2026-04-03T04:19:58.933+00:00',
        'dateScheduled': '2026-01-07T13:54:21.000+00:00',
        'dateStarted': '2026-04-03T04:31:12.118+00:00',
        'dateLastModified': '2026-04-03T04:31:12.204+00:00',
        'toBePrinted': false,
        'pickItems': [
            {
                'id': 547,
                'part': {
                    'id': 79,
                    'name': 'B203',
                    'description': 'Basic Brake Cables'
                },
                'status': 'Started',
                'type': 'Normal',
                'quantity': '8',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 156
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'currentTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            },
            {
                'id': 549,
                'part': {
                    'id': 12,
                    'name': 'AC-01',
                    'description': 'Aluminum Casing'
                },
                'status': 'Started',
                'type': 'Normal',
                'quantity': '3',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 2,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 158
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceLocation': {
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            },
            {
                'id': 552,
                'part': {
                    'id': 12,
                    'name': 'AC-01',
                    'description': 'Aluminum Casing'
                },
                'status': 'Short',
                'type': 'Normal',
                'quantity': '1',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 2,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 158
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            }
        ],
        'customFields': []
    },
};

const data: RequestDefinitionData = {
    id: 'start-pick',
    title: 'Start a pick',
    description: 'Starts a pick. Each pickable item is assigned a source location and tag, and the items — and the pick — are moved to "Started". '
        + 'Returns the full pick object, the same shape as "Get a pick", reflecting the post-start item statuses and assigned source locations. '
        + 'Only a pick in "Entered" status can be started; "Started", "Committed", and "Finished" return a 400 error naming the pick\'s current status. '
        + 'A partial start is allowed: items with available inventory are started, and an item with only partial availability is split so the sourceable portion starts and the remainder comes back "Short" — as shown in the example response. '
        + 'If no item can be started because there is no inventory available to pick, nothing is saved, the pick is left in "Entered", and a 400 error is returned. '
        + 'Non-inventory items are skipped by the sourcing pass and keep their status. '
        + 'Because starting a pick can split lines and merge mergeable ones, the pick item IDs in the response are not guaranteed to match those from a pre-start "Get a pick" call. '
        + 'Requires PICK_START access right. Validates location group access — returns 403 if the user does not have access to the pick\'s location group. Returns 404 if the pick is not found.',
    endpoint: {
        verb: 'POST',
        path: '/picks/:id/start',
        tooltip: 'Start a pick',
    },
    attributes: [],
    requestObject: startPickRequest,
    responseObject: startPickResponse,
};

export default data;
